import { Component, OnInit } from '@angular/core';
import { HttpService } from '../http.service';

@Component({
  selector: 'app-payment-pending',
  templateUrl: './payment-pending.component.html',
  styleUrls: ['./payment-pending.component.scss'],
})
export class PaymentPendingComponent implements OnInit {
  message: any;
  chegUrl: any;
  deviceType: string = '';
  constructor(private httpService: HttpService) {
    this.message = this.httpService.getLocalStorage('Message');
    this.deviceType = this.httpService.getLocalStorage('DeviceType');
    this.chegUrl = this.httpService.getLocalStorage('ChegUrl');
    if (this.deviceType == 'web') {
      setTimeout(() => {
        window.open(this.chegUrl, '_self');
      }, 5000);
    }
  }
  
  ngOnInit(): void {}
}
